import { Form, Input, InputNumber, Select, Textarea } from '@seiue/ui'
import { FormInstance } from 'antd'
import humps from 'humps'
import { DateTypeEnum, SelectTypeEnum } from 'packages/sdks-next/growp'
import React from 'react'
import styled from 'styled-components'

import { DatePicker } from '../DatePicker'
import { DatePickerRange } from '../DatePickerRange'

import { NumberRange } from './NumberRange'
import { FormConfig, FormItemConfig, ISearchFormItemType } from './types'
import { handleInputValue, onpressEnterSearch } from './utils'

/**
 * 筛选表单
 *
 * @param param - 参数
 * @param param.formConfig - 表单配置项
 * @returns React.ReactNode
 */
export const SearchFormItems: React.FC<{
  formConfig: FormConfig
  onPressEnter?: () => void
  form?: FormInstance
}> = ({ formConfig, onPressEnter, form }) => {
  const selectComponent = (item: FormItemConfig) => {
    const { type, name, otherConfig } = item
    const humpName = humps.camelize(name)
    switch (type) {
      case ISearchFormItemType.Input: {
        return (
          <Input
            placeholder="请输入"
            {...otherConfig}
            id={humpName}
            onPressEnter={(e) => onpressEnterSearch(e, onPressEnter)}
          />
        )
      }
      case ISearchFormItemType.Number: {
        return (
          <InputNumber
            placeholder="请输入"
            {...otherConfig}
            id={humpName}
            onPressEnter={(e) => onpressEnterSearch(e, onPressEnter)}
          />
        )
      }
      case ISearchFormItemType.Select: {
        return (
          <Select
            placeholder="请选择"
            {...otherConfig}
            id={humpName}
            allowClear={true}
          />
        )
      }
      case ISearchFormItemType.Multi: {
        return (
          <Select
            showArrow={true}
            placeholder="请选择"
            {...otherConfig}
            mode={
              otherConfig?.metadata?.selectType
                ? otherConfig?.metadata?.selectType === SelectTypeEnum.Checked
                  ? 'multiple'
                  : undefined
                : 'multiple'
            }
            id={humpName}
            allowClear={true}
          />
        )
      }
      case ISearchFormItemType.TextArea: {
        return (
          <Textarea
            placeholder="请选择"
            autoSize={{ minRows: 2 }}
            {...otherConfig}
            id={humpName}
          />
        )
      }
      case ISearchFormItemType.DateRange: {
        return (
          <DatePickerRange
            dateType={otherConfig?.metadata?.dateType || DateTypeEnum.Date}
            id={humpName}
            placeholder={['开始时间', '结束时间']}
            {...otherConfig}
          />
        )
      }
      case ISearchFormItemType.TimeRange: {
        return (
          <DatePickerRange
            dateType={otherConfig?.metadata?.dateType || DateTypeEnum.Time}
            placeholder={['开始时间', '结束时间']}
            id={humpName}
            {...otherConfig}
          />
        )
      }
      case ISearchFormItemType.NumRange: {
        return (
          <NumberRange
            id={humpName}
            {...(otherConfig?.inputNumberProps || {})}
          />
        )
      }
      case ISearchFormItemType.Date: {
        return (
          <DatePicker
            id={humpName}
            dateType={otherConfig?.metadata?.dateType || DateTypeEnum.Date}
            placeholder={'选择日期'}
            {...otherConfig}
          />
        )
      }
      default: {
        return 'form config error'
      }
    }
  }

  const formItemRender = () => {
    return Object.keys(formConfig).map((key) => {
      const title = key === '-' ? null : <TitleDiv key={key}>{key}</TitleDiv>
      const formItems = formConfig[key]
        .filter((i) => i.type !== ISearchFormItemType.Null)
        .map((item: FormItemConfig, index: number) => {
          return (
            <FormItem
              key={item.name}
              label={item.label}
              name={item.name}
              valuePropName={item.valuePropName}
              normalize={(v) =>
                Array.isArray(v) ? (v.length === 0 ? undefined : v) : v
              }
            >
              {selectComponent(item)}
            </FormItem>
          )
        })
      return (
        <React.Fragment key={key}>
          {formItems.length === 0 ? null : (
            <FormGroupWrapper key={key}>
              {title}
              {formItems}
            </FormGroupWrapper>
          )}
        </React.Fragment>
      )
    })
  }
  return <>{formItemRender()}</>
}

const FormItem = styled(Form.Item)`
  .ant-picker-range {
    width: 100%;
  }
`

const TitleDiv = styled.div`
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: ${(props) => props.theme.text._1};
`

const FormGroupWrapper = styled.div`
  margin-bottom: 32px;
`
